import { render, staticRenderFns } from "./ItsBaseSecondaryColdStorage.vue?vue&type=template&id=0d9e0fd9&scoped=true&"
import script from "./ItsBaseSecondaryColdStorage.vue?vue&type=script&lang=js&"
export * from "./ItsBaseSecondaryColdStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9e0fd9",
  null
  
)

export default component.exports